export const important = "kRd";
export const hasAttachments = "lRd";
export const meeting = "mRd";
export const meetingAccepted = "nRd";
export const meetingDeclined = "oRd";
export const meetingTentative = "pRd";
export const meetingCanceled = "qRd";
export default {important,hasAttachments,meeting,meetingAccepted,meetingDeclined,meetingTentative,meetingCanceled};